import React from "react";
import { useSelector } from "react-redux";
import { useSetDefaultValue, usePendingPrefill } from "@hooks/index";
import PropTypes from "prop-types";
import { RESIDENTIAL_STATUS } from "@constants/commonConstants";
import { Input } from "@components/input";
import { useFormikContext } from "formik";

export const shouldShowResidentialPayment = ({residentialStatus}) => [
    RESIDENTIAL_STATUS.RENTING, 
    RESIDENTIAL_STATUS.MORTGAGE, 
    RESIDENTIAL_STATUS.BOARDING
  ].includes(residentialStatus);

const getShortResidentialStatus = (residentialStatus) => {
  switch(residentialStatus) {
    case RESIDENTIAL_STATUS.RENTING: {
      return "rent"
    }
    case RESIDENTIAL_STATUS.BOARDING: {
      return "board"
    }
    default: {
      return (residentialStatus || "").toLowerCase();
    }
  }
};

const name = "residentialPayment";

const ResidentialPaymentInput = ({ handleChange, handleBlur, values = {}, errors, touched }) => {
  const { initialValue: { loanReason } } = useSelector(state => state.loanForm);
  const { residentialStatus } = values;
  const shouldShow = shouldShowResidentialPayment(values);
  const shortResidentialStatus = getShortResidentialStatus(residentialStatus);
  const toolTipRent = loanReason === "Bond Loan" &&  shortResidentialStatus === "rent" ? "This should be for your new rental property." : "";

  useSetDefaultValue(name);
  usePendingPrefill(name);

  return (
    <>
      {shouldShow && (
        <Input
          title={`What will be your share of the ${shortResidentialStatus} weekly`}
          placeholder="Your share..."
          toolTipText={`Only include your share of the ${shortResidentialStatus} payment. ` + toolTipRent}
          type="number"
          prefix={<span>$</span>}
          maxLength={5}

          name={name}
          value={values[name]}
          onChange={handleChange}
          onBlur={handleBlur}
          errorMessage={touched[name] ? errors[name] : ""}
          values={values}
          customClass='residentialPayment'
        />
      )}
    </>
  );
}

export const __test__ = {
  ResidentialPayment: ResidentialPaymentInput
};

export default function ResidentialPayment() {
  const formikContext = useFormikContext();
  
  return (
    <ResidentialPaymentInput {...formikContext} />
  )
}

ResidentialPaymentInput.propTypes = {
  handleChange: PropTypes.func,
  handleBlur: PropTypes.func,
  values: PropTypes.object,
  errors: PropTypes.object,
  touched: PropTypes.object
};